export default "__VITE_ASSET__71006eeb__$_?nuxt_component=async__"